import React from 'react';
import { motion } from 'framer-motion';
import styles from './Ecosystem.module.css';
import { showComingSoon } from '../../App';
import soluckyLogo from './assets/solucky.png';

const projects = [
  {
    name: 'Solucky',
    logo: <img src={soluckyLogo} alt="Solucky" className={styles.projectLogo} />,
    description: 'Decentralized lottery platform'
  },
  {
    name: 'Gamba',
    logo: '🎲',
    description: 'On-chain gambling protocol'
  },
  {
    name: 'MemeFlips',
    logo: '🎭',
    description: 'Meme-based betting games'
  }
];

const Ecosystem = () => {
  return (
    <section className={`${styles.ecosystem} section`}>
      <div className="container">
        <motion.div
          className={styles.content}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className={styles.title}>
            Building the future of Solana's Gambling Ecosystem
          </h2>

          <div className={styles.projects}>
            {projects.map((project, index) => (
              <motion.div
                key={index}
                className={styles.project}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
              >
                <div className={styles.logo}>{project.logo}</div>
                <h3>{project.name}</h3>
                <p>{project.description}</p>
              </motion.div>
            ))}
          </div>

          <div className={styles.community}>
            <h3>Join Our Community</h3>
            <div className={styles.links}>
              <a href="#!" onClick={(e) => { e.preventDefault(); showComingSoon(); }} className={styles.link}>Discord</a>
              <a href="#!" onClick={(e) => { e.preventDefault(); showComingSoon(); }} className={styles.link}>Twitter</a>
            </div>
            <a href="#!" onClick={(e) => { e.preventDefault(); showComingSoon(); }} className={styles.grantsCta}>
              Apply for Hackathon Grants
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Ecosystem; 